import TareaService from 'src/modules/tarea/tareaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'TAREA_VIEW';

const tareaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: tareaViewActions.FIND_STARTED,
      });

      const record = await TareaService.find(id);

      dispatch({
        type: tareaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: tareaViewActions.FIND_ERROR,
      });

      getHistory().push('/tarea');
    }
  },
};

export default tareaViewActions;
